<app-moniepoint-dialog [dialogType]="'filter'" [className]="'filter'" [icon]="icon">
    <h2 class="modal-title">
        Pricing Details
    </h2>
    <app-pricing-list [pricingData]="details"></app-pricing-list>
    <div class="button-size-193 m-t-14">
        <app-custom-submit-button (submitForm)="cancelModal()" [block]="true"
            class="btn btn-block"
            name="Close">
        </app-custom-submit-button>
    </div>
</app-moniepoint-dialog>

<ng-template #icon>
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.1" cx="35" cy="35" r="35" fill="#0361F0" />
        <path
            d="M36.4947 51.6116C35.6102 51.6142 34.7615 51.2624 34.1381 50.6349L21.0764 37.5766C20.3872 36.8896 20.0339 35.935 20.1097 34.9649L20.9431 24.0216C21.0621 22.3744 22.3754 21.066 24.0231 20.9532L34.9664 20.1199C35.0531 20.1016 35.1381 20.1016 35.2247 20.1016C36.1075 20.1005 36.9541 20.4521 37.5764 21.0782L50.6381 34.1349C51.2635 34.7601 51.6149 35.6081 51.6149 36.4924C51.6149 37.3767 51.2635 38.2247 50.6381 38.8499L38.8514 50.6349C38.2278 51.2621 37.3792 51.6138 36.4947 51.6116ZM29.4231 26.0882C27.9144 26.0887 26.5942 27.1023 26.2041 28.5596C25.814 30.0169 26.4513 31.5546 27.7579 32.3086C29.0646 33.0627 30.7148 32.8452 31.7814 31.7782L31.7931 31.7682L31.8047 31.7566L31.7914 31.7682C32.7388 30.8125 33.0186 29.3808 32.5007 28.1387C31.9828 26.8967 30.7688 26.0878 29.4231 26.0882Z"
            fill="#0361F0" />
    </svg>    
</ng-template>